<style lang="scss" scoped>
@import "resources/sass/v1/abstracts/_variables";

.training-card {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

    .zoom-wrapper {
        overflow: hidden;
        height: 223px;

        @media screen and (min-width: $screen-md) {
            height: 279px;
        }

        @media screen and (min-width: $screen-lg) {
            height: 378px;
        }

        @media screen and (min-width: $screen-xl) {
            height: 276px;
        }
    }

    &.locked {
        box-shadow: none;
        position: relative;

        a {
            z-index: 2;
        }

        h3,
        p,
        span,
        img,
        .tags,
        .read-more {
            opacity: 0.5;
        }

        p {
            opacity: 0.3;
            color: transparent;
            text-shadow: 0 0 5px rgba(18, 18, 18, 0.35);
            -webkit-user-select: none; /* Safari */
            -moz-user-select: none; /* Firefox */
            -ms-user-select: none; /* IE10+/Edge */
            user-select: none; /* Standard */
        }

        &:after {
            content: url("/svg/article-locked.svg");
            width: 65px;
            height: 77px;
            position: absolute;
            right: 0;
            top: 0;
        }
    }

    .image-wrapper {
        object-fit: cover;
        object-position: center;
        font-family: "object-fit: cover;";
        transition: transform 0.2s;
    }

    &:hover:not(.locked) {
        .image-wrapper {
            transform: scale(1.1);
        }
    }
    .location {
        &:before {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            content: url("/svg/icons/icon-location-gray.svg");
        }
    }

    .date {
        &:before {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            content: url("/svg/icons/icon-calendar-gray.svg");
        }
    }
}
</style>

<template>
    <div class="training-card w-100 h-100" :class="{ 'locked': training.locked && !isMember }">
        <a class="d-inline-block w-100 h-100 d-flex flex-column" :href="trainingUrl">
            <div class="zoom-wrapper w-100">
                <img class="image-wrapper lazyload w-100 h-100" :data-src="image">
            </div>

            <div class="training-content p-24 flex-grow-1 d-flex flex-wrap">
                <div class="tags mb-16 w-100" v-if="training.category">
                    <span class="d-inline-block tag hover-none" :class="{ 'invisible': !training.category }">{{ training.category.name }}</span>
                </div>
                <h3 class="mb-40 w-100 h5" v-html="training.title"></h3>
                <div class="align-self-end">
                    <div class="training-data w-100 mb-32">
                        <small v-if="!training.e_learning" class="date mr-40 text-gray d-inline-flex align-items-center">{{ readableDate }}</small>
                        <small v-if="location" class="location text-gray d-inline-flex align-items-center">{{ location }}</small>
                    </div>
                    <span class="read-more">{{ translations.read_more }}</span>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import nlBe from 'dayjs/locale/nl-be'

dayjs.locale(nlBe)

export default {
    props: {
        training: {
            type: Object,
            required: true
        },
        isMember: {
            type: Boolean,
            required: true,
        },
        translations: {
            type: Object,
            required: true
        },
    },

    methods: {
        toKebabCase(string) {
            return string &&
                string
                    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
                    .map(x => x.toLowerCase())
                    .join('-');
        }
    },

    computed: {
        image() {
            /*if (this.training.image != null) {
                return `data:image/png;base64,${this.training.image}`;
            }*/

            if (this.training.category != null) {
                if (this.training.category.id === "05" || this.training.category.name === "Software") {
                    return '/images/software.png';
                }

                if (this.training.category.id === "01" || this.training.category.name === "Nomenclatuur/wetgeving") {
                    return '/images/nomenclatuur-en-wetgeving.png';
                }

                if (this.training.category.id === "06" || this.training.category.name === "Verpleegtechnische en praktijkgerichte opleidingen") {
                    return '/images/verpleegtechnische.png';
                }
            }

            return '/images/ct-paramedics.png';
        },

        readableDate() {
            if (this.training.dates.length > 1) {
                return 'Meerdere datums'
            }
            return dayjs(this.training.dates[0]).locale('nl-be').format('D MMMM YYYY')
        },

        location() {
            if (this.training.locations.length > 1) {
                return 'Meerdere locaties'
            }
            if (this.training.locations.length === 0) {
                return null
            }
            return this.training.locations[0].city
        },

        slug() {
            return this.toKebabCase(this.training.title)
        },

        trainingUrl() {
            return route('nl.training', { id: this.training.id, slug: this.slug })
        },
    }
}
</script>